import { render, staticRenderFns } from "./prodSalesReport.vue?vue&type=template&id=cfc0525c"
import script from "./prodSalesReport.vue?vue&type=script&lang=js"
export * from "./prodSalesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports